import React, {useState,useEffect, useContext } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { postData } from '../../config/api-connect';
import { LeaveContext } from '../../contexts/LeaveContext';
import {Popconfirm, Tooltip  } from 'antd';
// import { DollarCircleOutlined, LogoutOutlined, UserOutlined, FileAddOutlined, FileSearchOutlined, DashboardOutlined, DatabaseOutlined, SolutionOutlined, MoneyCollectOutlined } from '@ant-design/icons';
import { DollarCircleOutlined, LogoutOutlined, UserOutlined, AppstoreFilled, 
  AppstoreOutlined, BankFilled, BankOutlined, DatabaseFilled, DatabaseOutlined, 
  ContactsFilled, ContactsOutlined, FilterFilled, FilterOutlined,
  IdcardOutlined,TeamOutlined,AuditOutlined,SolutionOutlined
} from '@ant-design/icons';
import * as Styled from './style.js';
import logo from '../../assets/images/sp-logo-white.png';
import { usePermission } from '../../contexts/PermissionContext';

function SideBar() {
  const { pendingLeaveCount } = useContext(LeaveContext) || { pendingLeaveCount: 0 };
  const { hasPermission } = usePermission();
  const [leadsOpen,setLeadsOpen]= useState(false)
  const [batchesOpen, setBatchesOpen] = useState(false);
  const [coachesOpen,setCoachesOpen] = useState(false)
  const [customersOpen,setCustomersOpen] = useState(false)
  const [visitorsOpen,setVisitorsOpen] = useState(false)
  const [hrOpen,setHrOpen] = useState(false)
  const location = useLocation();
  const navigate = useNavigate();
  const isLeadsRoute = location.pathname.includes('/hot-leads') || 
                    location.pathname.includes('/leads-processed') || 
                    location.pathname.includes('/leads-generated') ||
                    location.pathname.includes('/lead-pipeline');

  const isVisitorsRoute = location.pathname.includes('/visitors')

  const isHrRoute =
    location.pathname.includes('/hr/buddy-attendance') ||
    location.pathname.includes('/hr/staff-management') ||
    location.pathname.includes('/leaves') ||
    location.pathname.includes('/careers');

  useEffect(()=>{
    if(location.pathname.includes('/customers')) {
      setCustomersOpen(true)
    }
    else if(isVisitorsRoute) {
      setVisitorsOpen(true)
    }
    else if(isHrRoute) {
      setHrOpen(true)
    }
  },[location.pathname])   

  const logout = () => {
    postData('/auth/logout', {})
      .then(() => {
        localStorage.setItem('access_id', '');
        localStorage.setItem('user_role', '');
        localStorage.setItem('user_name', '');
        navigate('/');
        window.location.reload();
      })
      .catch((error) => {
        console.error('Logout error:', error);
        localStorage.setItem('access_id', '');
        localStorage.setItem('user_role', '');
        localStorage.setItem('user_name', '');
        navigate('/');
        window.location.reload();
      });
  };

  const handleLeadsClick = () => {
    if (leadsOpen) {
      setLeadsOpen(false);
    } else {
      setLeadsOpen(true);
      setBatchesOpen(false);
      setCustomersOpen(false)
      setVisitorsOpen(false);
      setHrOpen(false);
      navigate('/lead-pipeline');
    }
  };
  
  const handleBatchesClick = () => {  // Add this function
    if (batchesOpen) {
      setBatchesOpen(false);
    } else {
      setBatchesOpen(true);
      setLeadsOpen(false);
      setCustomersOpen(false)
      setVisitorsOpen(false);
      setHrOpen(false);
      navigate('/batches/utilization');
    }
  };

  const handleVisitorsClick = () => {
    if (visitorsOpen) {
      setVisitorsOpen(false);
    } else {
      setVisitorsOpen(true)
      setLeadsOpen(false);
      setBatchesOpen(false);
      setCustomersOpen(false)
      setHrOpen(false);
      navigate('/visitors/id-cards');
    }
  };

  const handleCoachesClick = () => {
    if (coachesOpen) {
      setCoachesOpen(false)
    } else {
      setCoachesOpen(true)
      setBatchesOpen(false);
      setLeadsOpen(false);
      setCustomersOpen(false)
      setVisitorsOpen(false);
      setHrOpen(false);
      navigate('/coaches');
    }
  };

  const handleCustomersClick = () => {
    if(customersOpen) {
      setCustomersOpen(false)
    }
    else {
      setBatchesOpen(false)
      setLeadsOpen(false);
      setCustomersOpen(true)
      setVisitorsOpen(false);
      setCoachesOpen(false)
      setHrOpen(false)
      navigate('/customers')
    }
  }

  const handleHrClick = () => {
    if (hrOpen) {
      setHrOpen(false);
    } else {
      setHrOpen(true);
      setBatchesOpen(false);
      setLeadsOpen(false);
      setCustomersOpen(false);
      setVisitorsOpen(false);
      setCoachesOpen(false);
      navigate('/leaves');
    }
  };

  const closeSubMenus = () => {
    setLeadsOpen(false);
    setBatchesOpen(false);
    setCustomersOpen(false)
    setCoachesOpen(false)
    setVisitorsOpen(false);
    setHrOpen(false);
  }


  return (
    <Styled.Sidebar>
      <Styled.SidebarContainer>
        <Styled.SidebarLogoContainer>
          <Styled.Logo src={logo} alt="logo" />
          <span style={{color:'white',fontWeight:'900'}}>Business Portal</span>
        </Styled.SidebarLogoContainer>

        <Styled.SidebarContainer>
          <Styled.SidebarMenuContainer>
            <Styled.SidebarItems>
              <Link to="/">
                <Styled.MenuContainer active={location.pathname === '/'} onClick={closeSubMenus}>
                  {location.pathname === '/' ?
                    <AppstoreFilled style={{color: 'white'}} /> 
                    : 
                    <AppstoreOutlined style={{color: '#047294'}} />
                  }
                  <Styled.MenuLabel active={location.pathname === '/'}>Dashboard</Styled.MenuLabel>
                </Styled.MenuContainer>
              </Link>

              <Styled.MenuContainer active={customersOpen} onClick={handleCustomersClick}>
                <UserOutlined style={{color: customersOpen ? 'white': '#047294'}}/>
                <Styled.MenuLabel active={customersOpen}>Customers</Styled.MenuLabel>
                {customersOpen ?
                  <Styled.LabelArrowHead>&#x25B2;</Styled.LabelArrowHead>
                  :
                  <Styled.LabelArrowHead>&#x25BC;</Styled.LabelArrowHead>
                }
              </Styled.MenuContainer>
              {customersOpen && (
                <>
                  <Link to="/customers">
                    <Styled.SubLabel active={location.pathname.includes('/customers')}>
                      Customer Analysis
                    </Styled.SubLabel>
                  </Link>
                  <Link to="/renewal-analysis">
                    <Styled.SubLabel active={location.pathname.includes('/renewal')}>
                      Renewal Analysis
                    </Styled.SubLabel>
                  </Link>
                  <Link to="/retention-analysis">
                    <Styled.SubLabel active={location.pathname.includes('/retention')}>
                      Retention Analysis
                    </Styled.SubLabel>
                  </Link>
                  <Link to="/customer-feedback">
                    <Styled.SubLabel active={location.pathname.includes('/customer-feedback')}>
                      Customer Feedback
                    </Styled.SubLabel>
                  </Link>
                </>
              )}
              
              <Link to="/revenue">
                <Styled.MenuContainer active={location.pathname.includes('/revenue')} onClick={closeSubMenus}>
                  <DollarCircleOutlined style={{color: (location.pathname.includes('/revenue') ? 'white': '#047294')}}/>
                  <Styled.MenuLabel active={location.pathname.includes('/revenue')}>Revenue</Styled.MenuLabel>
                </Styled.MenuContainer>
              </Link>

              {!["Partner", "Web Partner", "Technichal Partner"].includes(
                  localStorage.getItem("user_role")
                ) && (
                <Link to="/collection">
                  <Styled.MenuContainer active={location.pathname.includes('/collection')} onClick={closeSubMenus}>
                    {location.pathname.includes('/collection') ?
                      <BankFilled style={{color: 'white'}} /> 
                      : 
                      <BankOutlined style={{color: '#047294'}} />
                    }
                    <Styled.MenuLabel active={location.pathname.includes('/collection')}>Collection</Styled.MenuLabel>
                  </Styled.MenuContainer>
                </Link>
              )} 
              
              <Styled.MenuContainer 
                active={location.pathname.includes('/batches')} 
                onClick={handleBatchesClick}
              >
                {location.pathname.includes('/batches') ?
                  <ContactsFilled style={{color: 'white'}} /> 
                  : 
                  <ContactsOutlined style={{color: '#047294'}} />
                }
                <Styled.MenuLabel active={location.pathname === '/batches/attendance' || location.pathname === '/batches/utilization'}>Batches</Styled.MenuLabel>
                {location.pathname.includes('/batches') ?
                  <Styled.LabelArrowHead>&#x25B2;</Styled.LabelArrowHead>
                  :
                  <Styled.LabelArrowHead>&#x25BC;</Styled.LabelArrowHead>
                }
              </Styled.MenuContainer>

              {batchesOpen && (
                <>
                  <Link to="/batches/utilization">
                    <Styled.SubLabel active={location.pathname.includes('/batches/utilization')}>
                      Utilization
                    </Styled.SubLabel>
                  </Link>
                  <Link to="/batches/attendance/?page=summary">
                    <Styled.SubLabel active={location.pathname.includes('/batches/attendance') && location.search.includes('page=summary')}>
                      Attendance
                    </Styled.SubLabel>
                  </Link>
                  <Link to="/batches/attendance/?page=overall">
                    <Styled.SubLabel active={location.pathname.includes('/batches/attendance') && location.search.includes('page=overall')}>
                      Overall Attended
                    </Styled.SubLabel>
                  </Link>
                </>
              )}
              
              <Styled.MenuContainer 
                active={isLeadsRoute} 
                onClick={handleLeadsClick}
              >
                {isLeadsRoute ?
                  <DatabaseFilled style={{color: 'white'}} /> 
                  : 
                  <DatabaseOutlined style={{color: '#047294'}} />
                }
                <Styled.MenuLabel active={isLeadsRoute}>Leads</Styled.MenuLabel>
                {(leadsOpen || isLeadsRoute) ?
                  <Styled.LabelArrowHead>&#x25B2;</Styled.LabelArrowHead>
                  :
                  <Styled.LabelArrowHead>&#x25BC;</Styled.LabelArrowHead>
                }
              </Styled.MenuContainer>
              
              {(leadsOpen || isLeadsRoute) && (
                <>
                  <Link to="/lead-pipeline">
                    <Styled.SubLabel active={location.pathname.includes('/lead-pipeline')}>
                      Lead Pipeline
                    </Styled.SubLabel>
                  </Link>
                  <Link to="/leads-generated">
                    <Styled.SubLabel active={location.pathname === '/leads-generated'}>
                      Lead Conversion
                    </Styled.SubLabel>
                  </Link>
                  <Link to="/hot-leads">
                    <Styled.SubLabel active={location.pathname === '/hot-leads'}>
                      Pending To Process
                    </Styled.SubLabel>
                  </Link>
                  <Link to="/leads-processed">
                    <Styled.SubLabel active={location.pathname === '/leads-processed'}>
                      Leads Processed
                    </Styled.SubLabel>
                  </Link>
                </>
              )}

              <Styled.MenuContainer 
                active={location.pathname.includes('/coaches')} 
                onClick={handleCoachesClick}
              >
                <TeamOutlined style={{color: location.pathname.includes('/coaches') ? 'white' : '#047294'}} /> 
                <Styled.MenuLabel active={location.pathname === '/coaches'}>Coaches</Styled.MenuLabel>
              </Styled.MenuContainer>

              {hasPermission('access_finance_reimbursements') && (
                <Link to="/reimbursement">
                  <Styled.MenuContainer active={location.pathname.includes('/reimbursement')} onClick={closeSubMenus}>
                    {location.pathname.includes('/reimbursement') ?
                      <SolutionOutlined style={{color: 'white'}} />
                      :
                      <SolutionOutlined style={{color: '#047294'}} />
                    }
                    <Styled.MenuLabel active={location.pathname.includes('/reimbursement')}>Reimbursement</Styled.MenuLabel>
                  </Styled.MenuContainer>
                </Link>
              )}

              <Link to="/reports">
                <Styled.MenuContainer active={location.pathname.includes('/reports')} onClick={closeSubMenus}>
                  {location.pathname.includes('/reports') ?
                    <FilterFilled style={{color: 'white'}} />
                    :
                    <FilterOutlined style={{color: '#047294'}} />
                  }
                  <Styled.MenuLabel active={location.pathname.includes('/reports')}>Reports</Styled.MenuLabel>
                </Styled.MenuContainer>
              </Link>
              {(
                localStorage.getItem('user_role') === 'Delivery Manager' || 
                localStorage.getItem('user_role') === 'Trespasser' || 
                localStorage.getItem('user_role') === 'HR' ||
                localStorage.getItem('user_role') === 'Lead Buddy' || 
                localStorage.getItem('user_role') === 'Marketing Manager'
              ) && (
                <>
                  <Styled.MenuContainer
                    active={hrOpen || isHrRoute}
                    onClick={handleHrClick}
                  >
                    <AuditOutlined
                      style={{ color: (hrOpen || isHrRoute) ? 'white' : '#047294' }}
                    />
                    <Styled.MenuLabel active={hrOpen || isHrRoute} style={{display:'flex',alignItems:'center'}}>
                      HR
                      {!hrOpen && pendingLeaveCount > 0 && (
                        <Tooltip
                          title={
                            pendingLeaveCount === 1
                              ? 'A team member has applied for leave'
                              : `${pendingLeaveCount} team members have applied for leave`
                          }
                        >
                        <span
                          style={{
                            width: 8,
                            height: 8,
                            borderRadius: 4,
                            background: '#ff3b30',
                            marginLeft: 8,
                            display: 'inline-block',
                          }}
                        />
                        </Tooltip>
                      )}
                    </Styled.MenuLabel>
                    {hrOpen ?
                      <Styled.LabelArrowHead>&#x25B2;</Styled.LabelArrowHead>
                      :
                      <Styled.LabelArrowHead>&#x25BC;</Styled.LabelArrowHead>
                    }
                  </Styled.MenuContainer>
                  {hrOpen && (
                    <>
                      {(
                        localStorage.getItem('user_role') === 'Delivery Manager' || 
                        localStorage.getItem('user_role') === 'Trespasser' || 
                        localStorage.getItem('user_role') === 'HR' || pendingLeaveCount > 0
                      ) && (
                        <Link to="/leaves">
                          <Styled.SubLabel active={location.pathname.includes('/leaves')}>
                            Leaves
                            {hrOpen && pendingLeaveCount > 0 && (
                              <Tooltip
                                title={
                                  pendingLeaveCount === 1
                                    ? 'A team member has applied for leave'
                                    : `${pendingLeaveCount} team members have applied for leave`
                                }
                              >
                              <span
                                style={{
                                  width: 8,
                                  height: 8,
                                  borderRadius: 4,
                                  background: '#ff3b30',
                                  marginLeft: 8,
                                  display: 'inline-block',
                                }}
                              />
                              </Tooltip>
                            )}
                          </Styled.SubLabel>
                        </Link>
                      )}
                      {(
                        localStorage.getItem('user_role') === 'Delivery Manager' || 
                        localStorage.getItem('user_role') === 'Trespasser' || 
                        localStorage.getItem('user_role') === 'HR' ||
                        localStorage.getItem('user_role') === 'Lead Buddy'||
                        localStorage.getItem('user_role') === 'Marketing Manager'
                      ) && (
                        <Link to="/careers">
                          <Styled.SubLabel active={location.pathname.includes('/careers')}>
                            Careers
                          </Styled.SubLabel>
                        </Link>
                      )}
                      {['Trespasser','Delivery Manager','HR'].includes(localStorage.getItem('user_role')) && (
                        <>
                          <Link to="/hr/staff-attendance">
                            <Styled.SubLabel active={location.pathname.includes('/hr/staff-attendance')}>
                              Staff Attendance
                            </Styled.SubLabel>
                          </Link>
                          <Link to="/hr/staff-management">
                            <Styled.SubLabel active={location.pathname.includes('/hr/staff-management')}>
                              Staff Management
                            </Styled.SubLabel>
                          </Link>
                        </>
                      )}
                    </>
                  )}
                </>
              )}
            <Styled.MenuContainer active={isVisitorsRoute} onClick={handleVisitorsClick}>
              <IdcardOutlined style={{color: isVisitorsRoute ? 'white': '#047294'}}/>
              <Styled.MenuLabel active={isVisitorsRoute}>Visitors</Styled.MenuLabel>
              {visitorsOpen ?
                <Styled.LabelArrowHead>&#x25B2;</Styled.LabelArrowHead>
                :
                <Styled.LabelArrowHead>&#x25BC;</Styled.LabelArrowHead>
              }
            </Styled.MenuContainer>
            {visitorsOpen && (
                <>
                  <Link to="/visitors/list">
                    <Styled.SubLabel active={location.pathname.includes('/visitors/list')}>
                      Visitor List
                    </Styled.SubLabel>
                  </Link>
                  <Link to="/visitors/id-cards">
                    <Styled.SubLabel active={location.pathname === '/visitors/id-cards'}>
                      ID Cards
                    </Styled.SubLabel>
                  </Link>
                </>
              )}
              {/*<Link to="/">
                <Styled.MenuOption active={location.pathname === '/'}>
                  <DashboardOutlined style={{ color: '#fcd533' }} />
                  <Styled.MenuLabel>Dashboard</Styled.MenuLabel>
                </Styled.MenuOption>
              </Link>

              <Link to="/salaryDetails">
                <Styled.MenuOption active={location.pathname === '/salaryDetails'}>
                  <DatabaseOutlined />
                  <Styled.MenuLabel>Salary Details</Styled.MenuLabel>
                </Styled.MenuOption>
              </Link>
              <Link to="/addBuddyData">
                <Styled.MenuOption active={location.pathname === '/addBuddyData'}>
                  <SolutionOutlined />
                  <Styled.MenuLabel>Add Buddy Data</Styled.MenuLabel>
                </Styled.MenuOption>
              </Link>

              <Link to="/buddyinfo">
                <Styled.MenuOption active={location.pathname === '/buddyinfo' || location.pathname === '/buddyData'}>
                  <SolutionOutlined style={{ color: '#fcd533' }} />
                  <Styled.MenuLabel>Buddy Details</Styled.MenuLabel>
                </Styled.MenuOption>
              </Link>*/}

              {/* <Link to="/expenseDetails">
                <Styled.MenuOption active={location.pathname === '/expenseDetails'}>
                  <SolutionOutlined />
                  <Styled.MenuLabel>Expense Details</Styled.MenuLabel>
                </Styled.MenuOption>
              </Link> */}

              {/* Uncomment the below code if required */}
              {/*<Link to="/addContract">
                <Styled.MenuOption active={location.pathname === '/addContract'}>
                  <FileAddOutlined />
                  <Styled.MenuLabel>Add Contract</Styled.MenuLabel>
                </Styled.MenuOption>
              </Link>

              <Styled.SidebarSubMenu>Venue Management</Styled.SidebarSubMenu>

              <Link to="/contractInfo">
                <Styled.MenuOption active={location.pathname === '/contractInfo'}>
                  <FileAddOutlined style={{ color: '#fcd533' }} />
                  <Styled.MenuLabel>Contracts</Styled.MenuLabel>
                </Styled.MenuOption>
              </Link>

              <Link to="/collection">
                <Styled.MenuOption active={location.pathname === '/collection'}>
                  <DollarCircleOutlined style={{ color: '#fcd533' }} />
                  <Styled.MenuLabel>Collection Verification</Styled.MenuLabel>
                </Styled.MenuOption>
              </Link>*/}
            </Styled.SidebarItems>
          </Styled.SidebarMenuContainer>

          <Popconfirm
            title="Are you sure to logout?"
            onConfirm={logout}
            onCancel={() => {}}
            okText="Yes"
            cancelText="No"
          >
            <Styled.SidebarFooter>
              <Styled.SidebarItemLabel>
                <UserOutlined />
                <Styled.Username> {localStorage.getItem('user_name')} </Styled.Username>
              </Styled.SidebarItemLabel>
              <LogoutOutlined className="sidebar-item-icon" />
            </Styled.SidebarFooter>
          </Popconfirm>
        </Styled.SidebarContainer>
      </Styled.SidebarContainer>
    </Styled.Sidebar>
  );
}

export default SideBar;
